import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MenuSelectBottom  = props => {
    const {
        visible,
        setVisible,
        excelDown,
        menuInsert,
        menuEdit,
    } = props;

return (visible && (

            <div className="btn-area-jb">
                <div className="btn-area-l">
                    <button className="memo-reg" onClick={() => excelDown()}>
                        <span className="ico ico-exl-down"></span>
                        엑셀 다운로드
                    </button>
                </div>
                <ul className="file-list">
                    <li>
                        <button className="btn-m add" onClick={() => menuInsert()}>추가</button>
                    </li>
                    <li>
                        <button className="btn-m modify" onClick={() => menuEdit()}>수정</button>
                    </li>
                </ul>
            </div>
        )
    );
};

export default MenuSelectBottom;